import * as React from 'react';

class SamlError extends React.PureComponent {
    public render() {
        return (
            <div className="row h-100 justify-content-center align-items-center">
                <div className="col-sm-12 col-md-10 col-lg-8">
                    <section>
                        <div className="alert alert-danger" role="alert">
                            Unable to process SAML response.
                        </div>
                        <div className="text-center">
                            <a href="/" className="btn btn-primary">Back to login</a>
                        </div>
                    </section>
                </div>
            </div>
        );
    }
}

export default SamlError;
